import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-221b884a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "img-container" }
const _hoisted_3 = { class: "blur-img" }
const _hoisted_4 = { class: "pb-4 pt-3 bg-blur" }
const _hoisted_5 = { class: "container pt-4 pb-5" }
const _hoisted_6 = { class: "text-primary mb-3" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "container px-0" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-6 col-12" }
const _hoisted_11 = { class: "container pb-4" }
const _hoisted_12 = { class: "text-primary mb-3" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = { class: "col-lg-6 col-12 mb-3 px-0" }
const _hoisted_15 = { class: "container pb-4" }
const _hoisted_16 = { class: "text-primary mb-3" }
const _hoisted_17 = { class: "container-lg container-fluid mb-5 pb-5 text-center w-100" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "container-fluid px-lg-5 px-2 mt-05" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "partners container-fluid my-3" }
const _hoisted_22 = { class: "d-flex justify-content-around overflow-auto bg-light mb-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title mx-3 d-none" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Partners & Innovators")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeScreen = _resolveComponent("WelcomeScreen")!
  const _component_WelcomeImageLoader = _resolveComponent("WelcomeImageLoader")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Partners = _resolveComponent("Partners")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("section", _hoisted_2, [
      _createVNode(_component_WelcomeScreen, {
        onLoaded: _ctx.onImgLoad,
        welcomeDetail: _ctx.Welcome
      }, null, 8, ["onLoaded", "welcomeDetail"])
    ], 512), [
      [_vShow, _ctx.isLoaded]
    ]),
    _withDirectives(_createVNode(_component_WelcomeImageLoader, null, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.whatWeDo.title), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.whatWeDo.content), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.whatWeDo.content2), 1)
        ]),
        _createElementVNode("section", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.whoDoesIt.title), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.whoDoesIt.content), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.howWeDoIt.title), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.howWeDoIt.content), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_17, [
          _createElementVNode("img", {
            src: require(`@/assets/png/infograph.svg`),
            alt: "homepage_desc",
            class: "img-fluid w-100"
          }, null, 8, _hoisted_18)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardData, (data) => {
          return (_openBlock(), _createBlock(_component_Card, {
            key: data.title,
            body: data,
            card: _ctx.cardStyle
          }, null, 8, ["body", "card"]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnerData, (partner) => {
          return (_openBlock(), _createBlock(_component_Partners, {
            key: partner,
            partner: partner
          }, null, 8, ["partner"]))
        }), 128))
      ]),
      _hoisted_23
    ])
  ]))
}